<template>
    <myViewer :img="img_lnk"></myViewer>
</template>

<script>
import myViewer from "../../components/myViewer";
export default {
    name: "viewer",
    components:{
        myViewer
    },
    data:function() {
        return{
            img_lnk:''
        }
    },
    mounted:function(){
        this.img_lnk = this.$base.getRequest().img_lnk;
    },
    methods: {
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/blank/viewer.vue